import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import type React from "react";

import type { IModalProps } from "@components/atoms/modal";

export type IShowModalOptions = Omit<
  IModalProps,
  "children" | "open" | "onClose"
> & {
  noBox?: boolean;
};

interface IModalState {
  isOpen: boolean;
  children: React.ReactNode;
  options?: IShowModalOptions;
}

const INIT_DATA: IModalState = {
  isOpen: false,
  children: <div />,
};

export const useModalStore = create<IModalState>()(
  subscribeWithSelector(
    devtools(() => INIT_DATA, {
      enabled: !import.meta.env.PROD,
      name: "modalStore",
    }),
  ),
);

export const showModal = (
  children: React.ReactNode,
  options?: IShowModalOptions,
) => {
  useModalStore.setState({
    isOpen: true,
    children,
    options,
  });
};

export const closeModal = () => {
  useModalStore.setState({ isOpen: false });
};

export const clearModalOptions = () => {
  useModalStore.setState({ options: undefined });
};
